<template>
  <v-expand-transition>
    <div v-show="obj.isOpen">
      <v-form v-model="isValid" ref="form">
        <v-card-text class="pa-0">
          <!-- 土量 -->
          <v-card-actions class="pr-0" v-show="config.useSoilVolumeCalculation">
            {{ $t("Soilvolume") }}
            <v-btn height="20px" icon v-if="isEditOnProgress" @click="calculateTrenchVolume(obj)" class="ml-3"
              title="ボリュームを計算する" :loading="obj.loadingVolume">
              <v-icon> mdi-play-circle-outline </v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <v-table class="ml-4 soil-volume-table" density="compact" v-if="config.useSoilVolumeCalculation">
              <tbody>
                <tr>
                  <td>
                    {{ $t("Cut") }}
                  </td>
                  <td>
                    <v-text-field variant="underlined" hide-details density="compact" type="number" min="0" step="0.1"
                      :suffix="volumeLabel" readonly :model-value="toDisplayVolume(obj.cutVolume ?? 0, 3).value" />
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-expand-transition>
          <!-- 中心線形 -->
          <v-card-actions class="pr-0">
            <v-btn icon size="24" @click="toggleVisibility" class="ml-0" v-if="isEditOnProgress">
              <v-icon>
                {{ obj.isShow ? "icon:View" : "icon:View-Off" }}
              </v-icon>
            </v-btn>
            <span class="ml-2">{{ $t("VISIBILITY") }}</span>
          </v-card-actions>
          <div class="ml-4">
            <v-card-actions class="py-0 item-list">
              <v-btn icon size="24" @click="toggleAlignmentVisibility" class="ml-0">
                <v-icon>
                  {{ obj.isAlignmentVisible ? "icon:View" : "icon:View-Off" }}
                </v-icon>
              </v-btn>
              <span class="ml-2">{{ $t("ALIGNMENT") }}</span>
            </v-card-actions>
            <div class="item-list ml-8">
              <v-card-actions class="py-0 item-list">
                <v-btn icon size="24" @click="toggleIpLineVisibility" class="ml-0">
                  <v-icon>
                    {{ obj.isVisible.ipLine ? "icon:View" : "icon:View-Off" }}
                  </v-icon>
                </v-btn>
                <span class="ml-2">{{ $t("IP_LINE") }}</span>
              </v-card-actions>
              <!-- 中心線 -->
              <v-card-actions class="py-0 item-list">
                <v-btn icon size="24" @click="toggleCenterLineVisibility" class="ml-0">
                  <v-icon>
                    {{ obj.isVisible.centerLine ? "icon:View" : "icon:View-Off" }}
                  </v-icon>
                </v-btn>
                <span class="ml-2">{{ $t("CENTER_LINE") }}</span>
              </v-card-actions>
            </div>
            <!-- 中心線 -->
            <v-card-actions class="py-0 item-list">
              <v-btn icon size="24" @click="toggleSurfaceVisibility" class="ml-0">
                <v-icon>
                  {{ obj.isVisible.surface ? "icon:View" : "icon:View-Off" }}
                </v-icon>
              </v-btn>
              <span class="ml-2">{{ $t("SURFACE") }}</span>
            </v-card-actions>
            <!-- 中心線 -->
            <v-card-actions class="py-0 item-list">
              <v-btn icon size="24" @click="toggleEmbankmentVisibility" class="ml-0">
                <v-icon>
                  {{ obj.isEmbankmentVisible ? "icon:View" : "icon:View-Off" }}
                </v-icon>
              </v-btn>
              <span class="ml-2">{{ $t("EMBANKMENT") }}</span>
            </v-card-actions>
            <!-- 断面線 -->
            <div class="item-list">
              <v-card-actions class="py-0">
                <v-btn icon size="24" @click="toggleCrossSectionVisibility" class="ml-0">
                  <v-icon>
                    {{ obj.isVisible.crossSection ? "icon:View" : "icon:View-Off" }}
                  </v-icon>
                </v-btn>
                <span class="ml-2">{{ $t("CROSS_SECTION") }}</span>
                <v-btn height="30px" icon v-if="isEditOnProgress" :disabled="!obj.isVisible.crossSection"
                  @click="onUpdateCrossSection" class="ml-3">
                  <v-icon>
                    mdi-play-circle-outline
                  </v-icon>
                </v-btn>
              </v-card-actions>
              <!-- 線形設定値 -->
              <v-card-actions class="section pr-2" @click="toggle('crossSection')" style="cursor: pointer;"
                v-if="isEditOnProgress">
                {{ $t("LineWorkparamater") }}
                <v-spacer></v-spacer>
                <v-icon size="small">{{ expanded.crossSection ? 'mdi-chevron-up' : 'mdi-chevron-down'
                  }}</v-icon>
              </v-card-actions>
              <v-expand-transition>
                <div v-show="expanded.crossSection">
                  <v-table density="compact">
                    <tbody>
                      <tr>
                        <td>{{ $t("WidthofLineWork") }} {{ $t("Left") }}</td>
                        <td>
                          <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="1"
                            :step="0.001" :disabled="!isEditOnProgress" :max-value="999.999" :decimal-length="3"
                            v-model="obj.crossSectionSetting.leftWidth" />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span style="opacity: 0">{{ $t("WidthofLineWork") }}</span>
                          {{ $t("Right") }}
                        </td>
                        <td>
                          <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="1"
                            :step="0.001" :disabled="!isEditOnProgress" v-model="obj.crossSectionSetting.rightWidth"
                            :max-value="999.999" :decimal-length="3" />
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("STATION_INTERVAL") }}</td>
                        <td>
                          <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="1"
                            :step="0.001" :disabled="!isEditOnProgress"
                            v-model="obj.crossSectionSetting.interpolationPitch" :max-value="999.999"
                            :decimal-length="3" />
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </v-expand-transition>
            </div>
          </div>
          <!-- 編集モード時のみ表示 -->
          <template v-if="isEditOnProgress">
            <!-- 床掘 -->
            <v-card-actions class="pr-0">
              {{ $t("Trenchparameter") }}
            </v-card-actions>
            <v-table density="compact" class="ml-4">
              <tbody>
                <!-- 床掘幅 -->
                <tr>
                  <td>{{ $t("Widthoftrench") }} </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="0.001"
                      :max-value="9999.999" :decimal-length="3" :step="0.001" :disabled="!isEditOnProgress"
                      @blur="onBlur" v-model="obj.pathSettings.width" />
                  </td>
                </tr>
                <!-- 片勾配にする -->
                <tr>
                  <td>{{ $t("Setsuperelevation") }}</td>
                  <td>
                    <v-select variant="plain" v-model="obj.pathSettings.isSuperElevation" :items="slopeTypes"
                      item-title="label" item-value="value" density="compact" hide-details :disabled="!isEditOnProgress"
                      class="ma-0" v-on:update:model-value="updateSettings(true)">
                    </v-select>
                  </td>
                </tr>
                <!-- 片面勾配 -->
                <tr v-if="obj.pathSettings.isSuperElevation">
                  <td>{{ $t("Superelevation") }}</td>
                  <td>
                    <SlopeSettingInput :suffix-to-display="getSuffix(trenchParameterSlopeUnit.superElevation)"
                      :is-editable="isEditOnProgress" :slope-value="obj.pathSettings.leftSlope" :step="0.01"
                      @blur="onBlur" v-model.number="obj.pathSettings.leftSlope" :max-value="9999.99"
                      :min-value="-9999.99" :decimal-length="2"
                      :un-valid-zero="trenchParameterSlopeUnit.superElevation === 'percent'">
                    </SlopeSettingInput>
                  </td>
                </tr>
                <!-- 横断勾配 -->
                <tr v-else>
                  <td>
                    {{ $t("Crossslope") }}
                  </td>
                  <td>
                    <SlopeSettingInput :suffix-to-display="getSuffix(trenchParameterSlopeUnit.crossSlope)"
                      :is-editable="isEditOnProgress" :slope-value="obj.pathSettings.leftSlope" :step="0.01"
                      @blur="onBlur" v-model.number="obj.pathSettings.leftSlope" :max-value="9999.99" :min-value="0"
                      :decimal-length="2" :un-valid-zero="trenchParameterSlopeUnit.crossSlope === 'percent'">
                    </SlopeSettingInput>
                  </td>
                </tr>
                <!-- 摺り付けピッチ -->
                <tr>
                  <td>
                    {{ $t("InterpolationPitch") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="0.001"
                      :max-value="9999.999" :decimal-length="3" :step="0.001" :disabled="!isEditOnProgress"
                      @blur="onBlur" v-model="obj.pathSettings.interpolationPitch" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("Longitudinal_Slope_Type") }}
                  </td>
                  <td>
                    <v-select variant="plain" v-model="obj.pathSettings.longitudinalSlope.slopeType"
                      :items="longitudinalSlopeType" :disabled="!isEditOnProgress" item-title="label" item-value="value"
                      hide-details density="compact" class="ma-0"
                      v-on:update:model-value="updateSettings(true)"></v-select>
                  </td>
                </tr>
                <tr v-if="enableSpecifiedElevation">
                  <td class="text-pre-wrap">
                    <span v-text="$t('Specified_Elevation')"></span>
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="-9999.999"
                      :max-value="9999.999" :decimal-length="3" :step="0.001" :disabled="!isEditOnProgress"
                      @blur="onBlur" v-model="obj.pathSettings.specifiedElevation" />
                  </td>
                </tr>
                <tr v-if="enableSlopeValue">
                  <td>
                    {{ $t("Longitudinal_Slope_Value") }}
                  </td>
                  <td>
                    <SlopeSettingInput :suffix-to-display="getSuffix(trenchLongitudinalSlopeUnit)"
                      :is-editable="isEditOnProgress" :slope-value="obj.pathSettings.longitudinalSlope.slopeValue"
                      :step="0.01" @blur="onBlur" v-model.number="obj.pathSettings.longitudinalSlope.slopeValue"
                      :max-value="trenchLongitudinalSlopeUnit === 'percent' ? 9999.99 : 999.99"
                      :min-value="trenchLongitudinalSlopeUnit === 'percent' ? -100 : 0.01" :decimal-length="2"
                      :un-valid-zero="trenchLongitudinalSlopeUnit === 'percent'"></SlopeSettingInput>
                  </td>
                </tr>
                <tr v-if="enableDepth">
                  <td>
                    {{ $t("TRENCH_DEPTH") }}
                  </td>
                  <td>
                    <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="0.001"
                      :max-value="9999.999" :decimal-length="3" :step="0.001" :disabled="!isEditOnProgress"
                      @blur="onBlur" v-model="obj.pathSettings.longitudinalSlope.depth" />
                  </td>
                </tr>
              </tbody>
            </v-table>
            <!-- 摺り付け設定 -->
            <v-card-actions class="section ml-4 pr-2" @click="toggle('interpolation')" style="cursor: pointer;">
              {{ $t("RUBBLING_SETTINGS") }}
              <v-spacer></v-spacer>
              <v-icon size="small">{{ expanded.interpolation ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }}</v-icon>
            </v-card-actions>
            <v-expand-transition>
              <div v-show="expanded.interpolation" class="ml-4">
                <v-table density="compact">
                  <tbody>
                    <!-- 擦り付け先 -->
                    <tr>
                      <td>
                        {{ $t("RUBBLING_DESTINATION") }}
                      </td>
                      <td>
                        <v-select variant="plain" v-model="rubbingDestination.target" :disabled="!isEditOnProgress"
                          @update:model-value="updateRubbingDestinationTarget()" :items="rubbingDestinations"
                          item-title="label" item-value="value" hide-details density="compact" class="ma-0"></v-select>
                      </td>
                    </tr>
                    <tr v-if="rubbingDestination.target === 'pointcloud'">
                      <td>{{ $t("REFERENCE_POINT_CLOUD_ASSET") }}</td>
                      <td>
                        <v-select v-if="pointClouds.length > 0" variant="plain" v-model="rubbingDestination.id"
                          :disabled="!isEditOnProgress" :items="pointClouds"
                          :item-title="(item) => item && item.getName()"
                          :item-value="(item) => item && item.getAssetIdNum()" density="compact" hide-details
                          class="ma-0" @update:model-value="updateRubbingDestinationId()">
                        </v-select>
                      </td>
                    </tr>
                    <tr v-if="rubbingDestination.target === 'design'">
                      <td>{{ $t("REFERENCE_DESIGN_ASSET") }}</td>
                      <td>
                        <v-select variant="plain" v-model="rubbingDestination.id" :disabled="!isEditOnProgress"
                          :items="designs" :item-title="(item) => item && item.getName()"
                          :item-value="(item) => item && item.getAssetIdNum()" density="compact" hide-details
                          class="ma-0" @update:model-value="updateRubbingDestinationId()">
                        </v-select>
                      </td>
                    </tr>
                    <tr v-if="rubbingDestination.target === 'flatground'">
                      <td>{{ $t("REFERENCE_FLAT_GROUND") }}</td>
                      <td>
                        <v-select variant="plain" v-model="rubbingDestination.id" :disabled="!isEditOnProgress"
                          :items="flatGrounds" :item-title="item => item.name" :item-value="item => item.id"
                          density="compact" hide-details class="ma-0"
                          @update:model-value="updateRubbingDestinationId()">
                        </v-select>
                      </td>
                    </tr>
                    <tr v-if="rubbingDestination.target === 'specified-altitude'">
                      <td>{{ $t("SPECIFIED_ALTITUDE") }}</td>
                      <td>
                        <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="-9999.999"
                          :max-value="9999.999" :decimal-length="3" :step="0.001" :disabled="!isEditOnProgress"
                          @blur="updateRubbingDestinationSpecifiedAltitude()"
                          v-model="rubbingDestination.specifiedAltitude" />
                      </td>
                    </tr>
                    <tr v-if="rubbingDestination.target === 'reference-topology'">
                      <td>{{ $t("REFERENCE_TOPOLOGY") }}</td>
                      <td>
                        <v-select variant="plain" v-model="rubbingDestination.id" :disabled="!isEditOnProgress"
                          :items="drawing2dImages" :item-title="(item) => item && item.getName()"
                          :item-value="(item) => item && item.getAssetId()" density="compact" hide-details class="ma-0"
                          @update:model-value="updateRubbingDestinationId()">
                        </v-select>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </v-expand-transition>
            <!-- 切土設定 -->
            <v-card-actions class="section pr-2" @click="toggle('cut')" style="cursor: pointer;">
              {{ $t("Cutsetting") }}
              <v-spacer></v-spacer>
              <v-icon size="small">{{ expanded.cut ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-actions>
            <v-expand-transition>
              <div v-show="expanded.cut" class="ml-4">
                <v-table density="compact">
                  <tbody>
                    <!-- 法面高さ -->
                    <tr>
                      <td>
                        {{ $t("Slopeheight") }}
                      </td>
                      <td>
                        <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="0.001"
                          :max-value="99.999" :decimal-length="3" :step="0.001" :disabled="cutSlopeCondition"
                          v-model="obj.cutSettings.trenchHeight" @blur="onBlur" />
                      </td>
                    </tr>
                    <tr>
                      <!-- 法面勾配 -->
                      <td>
                        {{ $t("Slopegradient") }}
                      </td>
                      <td>
                        <SlopeSettingInput :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                          :is-editable="isEditOnProgress && !obj.cutSettings.isLeftRightDifferent"
                          :slope-value="obj.cutSettings.moundSlope" :step="0.01" @blur="onBlur"
                          v-model.number="obj.cutSettings.moundSlope"
                          :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                          :min-value="0.01" :decimal-length="2" :un-valid-zero="false">
                        </SlopeSettingInput>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                <!-- 小段設定 -->
                <v-card-actions class="section pr-2" @click="toggle('cutBerm')" style="cursor: pointer;">
                  {{ $t("BERM_SETTINGS") }}
                  <v-spacer></v-spacer>
                  <v-icon size="small">{{ expanded.cutBerm ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-card-actions>
                <v-expand-transition>
                  <div v-show="expanded.cutBerm">
                    <v-table density="compact">
                      <tbody>
                        <!-- 小段あり -->
                        <tr>
                          <td>
                            {{ $t("Thereisberm") }}
                          </td>
                          <td>
                            <v-checkbox hide-details density="compact" class="ma-0" :disabled="!isEditOnProgress"
                              @update:model-value="updateSettings(true)"
                              v-model="obj.cutSettings.generateShelf"></v-checkbox>
                          </td>
                        </tr>
                        <!-- 小段幅 -->
                        <tr>
                          <td>
                            {{ $t("Bermwidth") }}
                          </td>
                          <td>
                            <DistanceSettingInput variant="underlined" hide-details density="compact" :min-value="0.001"
                              :max-value="99.999" :decimal-length="3" :step="0.001" :disabled="cutSlopeCondition"
                              v-model="obj.cutSettings.shelfWidth" @blur="onBlur" />
                          </td>
                        </tr>
                        <!-- 小段勾配 -->
                        <tr>
                          <td>
                            {{ $t("Bermgradient") }}
                          </td>
                          <td>
                            <SlopeSettingInput :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                              :is-editable="!cutSlopeCondition" :slope-value="obj.cutSettings.shelfSlope" :step="0.01"
                              @blur="onBlur" v-model.number="obj.cutSettings.shelfSlope"
                              :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                              :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01" :decimal-length="2"
                              :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                            </SlopeSettingInput>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </div>
                </v-expand-transition>
                <!-- 左右設定 -->
                <v-card-actions class="section pr-2" @click="toggle('cutLeftRight')" style="cursor: pointer;">
                  {{ $t("Leftrightsetting") }}
                  <v-spacer></v-spacer>
                  <v-icon size="small">{{ expanded.cutLeftRight ? 'mdi-chevron-up' :
                    'mdi-chevron-down'
                  }}</v-icon>
                </v-card-actions>
                <v-expand-transition>
                  <div v-show="expanded.cutLeftRight">
                    <v-table density="compact">
                      <tbody>
                        <tr>
                          <td>
                            {{ $t("LeftRightSettings") }}
                          </td>
                          <td>
                            <v-checkbox hide-details density="compact" class="ma-0" :disabled="!isEditOnProgress"
                              @update:model-value="updateSettings()"
                              v-model="obj.cutSettings.isLeftRightDifferent"></v-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                    <div class="left-right-settings">
                      <v-table density="compact">
                        <tbody>
                          <tr>
                            <td colspan="2">
                              {{ $t("Leftcutsetting") }}
                            </td>
                          </tr>
                          <!-- 法面高さ -->
                          <tr>
                            <td>
                              {{ $t("Slopeheight") }}
                            </td>
                            <td>
                              <DistanceSettingInput variant="underlined" hide-details density="compact"
                                :min-value="0.001" :max-value="99.999" :decimal-length="3" :step="0.001"
                                :disabled="cutLeftRightCondition" v-model="obj.cutSettings.leftSlopeHeight"
                                @blur="onBlur" />
                            </td>
                          </tr>
                          <!-- 法面勾配 -->
                          <tr>
                            <td>
                              {{ $t("Slopegradient") }}
                            </td>
                            <td>

                              <SlopeSettingInput :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                                :is-editable="(isEditOnProgress && obj.cutSettings.isLeftRightDifferent)"
                                :slope-value="obj.cutSettings.leftMoundSlope" :step="0.01" @blur="onBlur"
                                v-model.number="obj.cutSettings.leftMoundSlope"
                                :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                :min-value="0.01" :decimal-length="2" :un-valid-zero="false">
                              </SlopeSettingInput>

                            </td>
                          </tr>
                          <!-- 小段幅 -->
                          <tr>
                            <td>
                              {{ $t("Bermwidth") }}
                            </td>
                            <td>
                              <DistanceSettingInput variant="underlined" hide-details density="compact"
                                :min-value="0.001" :max-value="99.999" :decimal-length="3" :step="0.001"
                                :disabled="cutLeftRightCondition" v-model="obj.cutSettings.leftShelfWidth"
                                @blur="onBlur" />
                            </td>
                          </tr>
                          <!-- 小段勾配 -->
                          <tr>
                            <td>
                              {{ $t("Bermgradient") }}
                            </td>
                            <td>

                              <SlopeSettingInput :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                                :is-editable="!cutLeftRightCondition" :slope-value="obj.cutSettings.leftShelfSlope"
                                @blur="onBlur" :step="0.01" v-model.number="obj.cutSettings.leftShelfSlope"
                                :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                :decimal-length="2" :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                              </SlopeSettingInput>

                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                      <v-table density="compact">
                        <tbody>
                          <tr>
                            <td colspan="2">
                              {{ $t("Rightcutsetting") }}
                            </td>
                          </tr>
                          <!-- 法面高さ -->
                          <tr>
                            <td>
                              {{ $t("Slopeheight") }}
                            </td>
                            <td>
                              <DistanceSettingInput variant="underlined" hide-details density="compact"
                                :min-value="0.001" :max-value="99.999" :decimal-length="3" :step="0.001"
                                :disabled="cutLeftRightCondition" v-model="obj.cutSettings.rightSlopeHeight"
                                @blur="onBlur" />
                            </td>
                          </tr>
                          <!-- 法面勾配 -->
                          <tr>
                            <td>
                              {{ $t("Slopegradient") }}
                            </td>
                            <td>

                              <SlopeSettingInput :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                                :is-editable="(isEditOnProgress && obj.cutSettings.isLeftRightDifferent)"
                                :slope-value="obj.cutSettings.rightMoundSlope" :step="0.01" @blur="onBlur"
                                v-model.number="obj.cutSettings.rightMoundSlope"
                                :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                :min-value="0.01" :decimal-length="2" :un-valid-zero="false">
                              </SlopeSettingInput>

                            </td>
                          </tr>
                          <!-- 小段幅 -->
                          <tr>
                            <td>
                              {{ $t("Bermwidth") }}
                            </td>
                            <td>
                              <DistanceSettingInput variant="underlined" hide-details density="compact"
                                :min-value="0.001" :max-value="99.999" :decimal-length="3" :step="0.001"
                                :disabled="cutLeftRightCondition" v-model="obj.cutSettings.rightShelfWidth"
                                @blur="onBlur" />
                            </td>
                          </tr>
                          <!-- 小段勾配 -->
                          <tr>
                            <td>
                              {{ $t("Bermgradient") }}
                            </td>
                            <td>

                              <SlopeSettingInput :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                                :is-editable="!cutLeftRightCondition" :slope-value="obj.cutSettings.rightShelfSlope"
                                @blur="onBlur" :step="0.01" v-model.number="obj.cutSettings.rightShelfSlope"
                                :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                :decimal-length="2" :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                              </SlopeSettingInput>

                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </div>
                  </div>
                </v-expand-transition>
              </div>
            </v-expand-transition>
            <!-- 色設定 -->
            <v-card-actions class="section pr-2" @click="toggle('color')" style="cursor: pointer;">
              {{ $t("COLOR_SETTINGS") }}
              <v-spacer></v-spacer>
              <v-icon size="small">{{ expanded.color ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-actions>
            <v-expand-transition>
              <div v-show="expanded.color" class="ml-4">
                <v-card-actions class="py-0 mr-3">
                  {{ $t("OPACITY") }}
                  <v-slider v-model="obj.transparency" :disabled="!isEditOnProgress" hide-details max="1" step="0.001"
                    class="ml-1" color="primary" track-size="0.5" thumb-size="14"></v-slider>
                </v-card-actions>
                <v-table density="compact">
                  <tbody>
                    <!-- 床面色 -->
                    <tr>
                      <td>
                        {{ $t("TRENCH_SURFACE_COLOR") }}
                      </td>
                      <td>
                        <v-menu :disabled="!isEditOnProgress">
                          <template v-slot:activator="{ props }">
                            <v-avatar :color="obj.pathSettings.surfaceColor" size="20px" v-bind="props">
                            </v-avatar>
                          </template>
                          <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders show-swatches mode="hexa"
                            v-model="obj.pathSettings.surfaceColor"></v-color-picker>
                        </v-menu>
                      </td>
                    </tr>
                    <!-- 法面色 -->
                    <tr>
                      <td>
                        {{ $t("SLOPE_COLOR") }}
                      </td>
                      <td>
                        <v-menu :disabled="!isEditOnProgress">
                          <template v-slot:activator="{ props }">
                            <v-avatar :color="obj.cutSettings.color" size="20px" v-bind="props">
                            </v-avatar>
                          </template>
                          <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders show-swatches mode="hexa"
                            v-model="obj.cutSettings.color"></v-color-picker>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </v-expand-transition>
          </template>
        </v-card-text>
      </v-form>
    </div>
  </v-expand-transition>
</template>

<script lang="ts">
import "@/assets/icons/style.css";
import config from "@/config.json";
import type { FlatgroundObject } from "@/models/objects/FlatgroundObject";
import type { TrenchObject } from "@/models/objects/TrenchObject";
import { ObjectType } from "@/models/objects/types.js";
import * as cesiumCommon from "@/utils/cesium-common";
import {
	notifySuccess,
	notifyWarning,
	notifyError,
} from "@/utils/notificationUtils";
import { useStore, mapMutations } from "vuex";
import { LongitudinalSlopeType, UnitTypes } from "../../../constant";
import {
	GoogleAnalyticsClickTypes,
	addClickTypeLog,
} from "../../../utils/googleAnalytics.js";
import SlopeRangeComponent from "../SlopeRangeComponent.vue";
import SlopeSettingInput from "../SlopeSettingInput.vue";
import NumericSettingInput from "../NumericSettingInput.vue";
import DistanceSettingInput from "../DistanceSettingInput.vue";
import { isCrossSectionSettingValid } from "./cross-section-validation";
import { useObjectPanel } from "./composables/useObjectPanel";
import { useUnitDisplay } from "@/composables/useUnitDisplay";

export default {
	setup(props) {
		const { obj, isValid, form } = useObjectPanel(props.objId);
		const store = useStore();
		const { toDisplayVolume, volumeLabel } = useUnitDisplay();
		return {
			obj: obj as unknown as TrenchObject,
			isValid,
			form,
			store,
			toDisplayVolume,
			volumeLabel,
		};
	},
	name: "TrenchPanel",
	emits: ["update:valid"],
	components: {
		SlopeSettingInput,
		SlopeRangeComponent,
		NumericSettingInput,
		DistanceSettingInput,
	},
	props: {
		objId: String,
		rules: Object,
	},
	computed: {
		isEditOnProgress() {
			return this.store.state.object.objectUnderEdit?.id === this.obj.id;
		},
		designs() {
			return this.store.state.design_list.filter(
				(item) => item.getIsAssetUploaded() === "DONE",
			);
		},
		pointClouds() {
			return this.store.state.point_cloud_list.filter(
				(item) => item.getIsAssetUploaded() === "DONE",
			);
		},
		flatGrounds() {
			return this.store.state.object.objects.filter(
				(item) => item.type === ObjectType.FLAT_GROUND,
			);
		},
		drawing2dImages() {
			return this.store.getters["drawing2dImage/getDrawing2dImageList"].filter(
				(item) => item.getIsAssetUploaded() === "DONE",
			);
		},
		trenchParameterSlopeUnit() {
			return this.store.state.trenchParameterSlopeUnit;
		},
		cutSettingSlopeUnit() {
			return this.store.state.trenchCutSettingSlopeUnit;
		},
		trenchLongitudinalSlopeUnit() {
			return this.store.state.trenchLongitudinalSlopeUnit;
		},
		// Disabling condition for cut setting's - shelfSlope, shelfWidth
		slopeTypes() {
			return [
				{
					label: this.$t("Crossslope"),
					value: false,
				},
				{
					label: this.$t("Superelevation"),
					value: true,
				},
			];
		},
		cutSlopeCondition() {
			return (
				!this.isEditOnProgress ||
				this.obj.cutSettings.isLeftRightDifferent ||
				!this.obj.cutSettings.generateShelf
			);
		},
		// Disabling condition for cut setting's - leftShelfWidth, leftShelfSlope, rightShelfWidth, rightShelfSlope
		cutLeftRightCondition() {
			return !(
				this.isEditOnProgress &&
				this.obj.cutSettings.isLeftRightDifferent &&
				this.obj.cutSettings.generateShelf
			);
		},
		rubbingDestinations() {
			const result = [];
			if (this.pointClouds.length > 0) {
				result.push({
					label: this.$t("POINT_CLOUD"),
					value: "pointcloud",
				});
			}
			if (this.designs.length > 0) {
				result.push({
					label: this.$t("DESIGN"),
					value: "design",
				});
			}
			if (this.flatGrounds.length > 0) {
				result.push({
					label: this.$t("FLAT_GROUND"),
					value: "flatground",
				});
			}
			if (this.drawing2dImages.length > 0) {
				result.push({
					label: this.$t("REFERENCE_TOPOLOGY"),
					value: "reference-topology",
				});
			}
			result.push({
				label: this.$t("SPECIFIED_ALTITUDE"),
				value: "specified-altitude",
			});
			return result;
		},
		longitudinalSlopeType() {
			return [
				{
					label: this.$t("LS_DEFAULT"),
					value: LongitudinalSlopeType.DEFAULT,
				},
				{
					label: this.$t("LS_FLAT"),
					value: LongitudinalSlopeType.FLAT,
				},
				{
					label: this.$t("LS_CONSTANT"),
					value: LongitudinalSlopeType.CONSTANT,
				},
				{
					label: this.$t("LS_NONE"),
					value: LongitudinalSlopeType.NONE,
				},
			];
		},
		enableSlopeValue() {
			return this.isSlopeType("constant");
		},
		enableSpecifiedElevation() {
			return (
				this.isSlopeType("flat") ||
				this.isSlopeType("constant") ||
				this.isSlopeType("default")
			);
		},
		enableDepth() {
			return this.isSlopeType("none");
		},
	},
	watch: {
		// "obj.rubbingDestination.target"() {
		// 	this.setInitialDestination();
		// },
		async "obj.pathSettings.longitudinalSlope.slopeType"() {
			// 床掘下面標高を使用する場合
			if (this.enableSpecifiedElevation) {
				// 始点の床掘下面標高が未入力の場合デフォルト値を設定
				if (this.obj.pathSettings.specifiedElevation === null) {
					if (this.elevation === "") {
						this.setElevation();
					}
					this.setSpecifiedElevation();
				}
			}

			// 勾配値を設定不可能な場合
			if (!this.enableSlopeValue) {
				// 初期値にする
				this.obj.pathSettings.longitudinalSlope.slopeValue = 0;
			}

			// 床掘高さを設定可能な場合
			if (this.enableDepth) {
				// 床掘高さが未入力の場合デフォルト値を設定
				if (this.obj.pathSettings.longitudinalSlope.depth === null) {
					this.obj.pathSettings.longitudinalSlope.depth = 1;
				}
			}
		},
		isValid(newVal) {
			this.$emit("update:valid", newVal);
		},
	},
	data() {
		return {
			config,
			expanded: {
				crossSection: false,
				interpolation: false,
				cut: false,
				cutBerm: false,
				cutLeftRight: false,
				color: false,
			},
			elevation: "",
			rubbingDestination: {
				target: null,
				id: null,
				specifiedAltitude: null,
			},
		};
	},
	methods: {
		...mapMutations(["set_snackbar", "reset_snackbars"]),
		toggle(section) {
			this.expanded[section] = !this.expanded[section];
		},
		setSpecifiedElevation() {
			const specifiedElevation = Number(this.elevation) - 1;
			this.obj.pathSettings.specifiedElevation = +specifiedElevation.toFixed(3);
		},
		getSuffix(unitType) {
			const unit = UnitTypes.find((type) => type.value === unitType);
			return unit.symbol;
		},
		isNum(val) {
			return typeof val == "number";
		},
		async onBlur() {
			await this.updateSettings(true);
		},
		async updateSettings(updateInViewer: boolean = false) {
			this.$store.dispatch("startObjectUpdating");
			try {
				await this.$nextTick();
				if (!this.obj.isShow) {
					updateInViewer = false;
				}
				const validation = await this.$refs.form?.validate();
				if (!validation.valid || !this.obj.rubbingDestination.id) return;
				await this.obj.update(this.obj, updateInViewer);

				if (updateInViewer && this.obj.crossSectionSetting) {
					await this.$store.dispatch(
						"lineWorksCrossSection/saveCrossSectionOfLineWorks",
						{
							crossSectionSetting: {
								...this.obj.crossSectionSetting,
								name: this.obj.name,
							},
						},
						{ root: true },
					);
				}
			} finally {
				this.$store.dispatch("endObjectUpdating");
			}
		},
		async updateRubbingDestinationId() {
			//load RubbingDestination if not loaded
			try {
				if (this.rubbingDestination.target === "flatground") {
					const flatground: FlatgroundObject =
						this.store.state.object.objects.find(
							(obj) =>
								obj.id === this.rubbingDestination.id &&
								obj.type === ObjectType.FLAT_GROUND,
						);
					if (!flatground) {
						throw new Error("Flatground not found");
					}
					flatground.setVisibility(true);
				} else {
					const terrain = this.store.getters.terrainList.find(
						(terrain) => terrain.getAssetIdNum() === this.rubbingDestination.id,
					);
					if (!terrain) {
						throw new Error("Terrain not found");
					}
					await cesiumCommon.setAssociatedTerrainVisible(terrain);
				}
				//update RubbingDestination
				this.obj.updateRubbingDestination(
					this.rubbingDestination.target,
					this.rubbingDestination.id,
					null,
				);
			} catch (error: unknown) {
				console.error(error);
				this.rubbingDestination.id = this.obj.rubbingDestination.id;
				this.rubbingDestination.target = this.obj.rubbingDestination.target;
			} finally {
				this.reset_snackbars();
			}
		},
		async updateRubbingDestinationTarget() {
			this.reset_snackbars();

			if (this.rubbingDestination.target === "specified-altitude") {
				const specifiedAltitude =
					this.store.getters.viewer.getAverageHeightOfFirstAndLastPointOfTrench(
						this.obj.id,
					);
				if (Number.isFinite(specifiedAltitude)) {
					this.rubbingDestination.specifiedAltitude = Number.parseFloat(
						Number(specifiedAltitude).toFixed(3),
					);
				}
				// Show instruction message until user completes the operation (timeout: -1 for manual dismissal)
				notifySuccess(
					{ $store: this.store, $t: this.$t },
					this.$t("SET_SPECIFIED_ALTITUDE"),
					-1,
				);
			} else {
				this.rubbingDestination.id = null;
				this.reset_snackbars();
				// Show instruction message until user completes the operation (timeout: -1 for manual dismissal)
				notifySuccess(
					{ $store: this.store, $t: this.$t },
					this.$t("SELECT_RUBBING_DESTINATION"),
					-1,
				);
			}
		},
		async updateRubbingDestinationSpecifiedAltitude() {
			this.reset_snackbars();
			this.$store.dispatch("startObjectUpdating");
			try {
				if (!this.obj.isShow) {
					// Update model data only, skip viewer update
					this.obj.rubbingDestination.specifiedAltitude =
						this.rubbingDestination.specifiedAltitude;
					return;
				}
				this.obj.updateRubbingDestination(
					"specified-altitude",
					null,
					this.rubbingDestination.specifiedAltitude,
				);
			} finally {
				this.$store.dispatch("endObjectUpdating");
			}
		},
		async calculateTrenchVolume(obj) {
			// Google Analyticsに連携
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_OBJECT_VOLUME_CALC);

			obj.loadingVolume = true;
			try {
				const res = await this.store.getters.viewer.volumeCalculationForTrench(
					obj.id,
				);
				obj.cutVolume = res.cutVolume?.toFixed(3);
				obj.fillVolume = res.fillVolume?.toFixed(3);
			} catch (error: unknown) {
				console.error(error instanceof Error ? error.message : error);
			} finally {
				obj.loadingVolume = false;
			}
			this.$forceUpdate();
		},
		unit() {
			return this.store.state.slopeUnit;
		},
		isSlopeType(slopeType) {
			return this.obj.pathSettings.longitudinalSlope.slopeType === slopeType;
		},
		setElevation() {
			this.elevation =
				this.store.getters.viewer.getReferencePointElevationOfTrench(
					this.obj.id,
				);
		},
		async toggleVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isShow;
						await this.obj.setVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle visibility:", e);
					}
				},
				{ root: true },
			);
		},
		// Center alignment visibility toggle
		async toggleCenterLineVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.centerLine;
						await this.obj.setCenterLineVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle center alignment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleIpLineVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.ipLine;
						await this.obj.setIpLineVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle ip line visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleAlignmentVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isAlignmentVisible;
						await this.obj.setAlignmentVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle alignment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleSurfaceVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.surface;
						await this.obj.setSurfaceVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle surface visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleEmbankmentVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isEmbankmentVisible;
						await this.obj.setEmbankmentVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle cut embankment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleCrossSectionVisibility() {
			await this.store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.crossSection;
						await this.obj.setCrossSectionVisibility(!currentState);
					} catch (e) {
						console.error("Failed to generate cross section:", e);
					}
				},
				{ root: true },
			);
		},
		async onUpdateCrossSection() {
			await this.store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						if (!isCrossSectionSettingValid(this.obj.crossSectionSetting)) {
							notifyError(this, this.$t("CROSS_SECTION_INVALID_VALUES"));
							return;
						}
						await this.obj.updateCrossSection();
					} catch (e) {
						console.error("Failed to update cross section visual:", e);
					}
				},
				{ root: true },
			);
		},
	},
	mounted() {
		this.rubbingDestination.target = this.obj.rubbingDestination.target;
		this.rubbingDestination.id = this.obj.rubbingDestination.id ?? null;
		this.rubbingDestination.specifiedAltitude =
			this.obj.rubbingDestination.target === "specified-altitude"
				? this.obj.rubbingDestination.specifiedAltitude
				: null;
	},
};
</script>

<style scoped>
div.trench-parameter .v-data-table table {
  table-layout: fixed
}

tr td {
  padding: 0 8px !important;
}

tr td:first-child {
  width: 115px;
}

.v-card-actions.section:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.08);
}

.v-table {
  background-color: transparent;
}

.soil-volume-table tr td:first-child {
  width: 80px;
  max-width: 80px;
}

.v-table :deep(.v-select .v-select__selection-text) {
  white-space: normal;
  font-size: 14px;
}
</style>
